import { render, staticRenderFns } from "./PrintViewFormattedHeader.vue?vue&type=template&id=f61b2c74&scoped=true&"
import script from "./PrintViewFormattedHeader.vue?vue&type=script&lang=js&"
export * from "./PrintViewFormattedHeader.vue?vue&type=script&lang=js&"
import style0 from "./PrintViewFormattedHeader.vue?vue&type=style&index=0&id=f61b2c74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61b2c74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/User/Documents/subhash/schoolportal/customerportal/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VLayout})
